import { AbstractMethodError } from "@awayjs/core";
var TextureBaseWebGL = (function () {
    function TextureBaseWebGL(gl) {
        this.textureType = "";
        this._gl = gl;
    }
    TextureBaseWebGL.prototype.dispose = function () {
        this._gl.deleteTexture(this._glTexture);
    };
    Object.defineProperty(TextureBaseWebGL.prototype, "glTexture", {
        get: function () {
            return this._glTexture;
        },
        enumerable: true,
        configurable: true
    });
    TextureBaseWebGL.prototype.generateMipmaps = function () {
        throw new AbstractMethodError();
    };
    return TextureBaseWebGL;
}());
export { TextureBaseWebGL };



// WEBPACK FOOTER //
// ../dist/lib/webgl/TextureBaseWebGL.js